import { OperatorsSelectList } from "../../../interfaces/endpoints/IOperators";
import { LineSelectList } from "../../../interfaces/endpoints/lines/ILines";
import { getLinesSelectList } from "../../../services/Lines.service";
import { getAllSelectOperators } from "../../../services/Operators.service";
import Select from "../../ui/select/Select";
import FilterPopover from "./FilterPopover";
import { RESERVATION_FILTER_KEYS as KEYS } from "./reservationFilters";
import useFilterParams from "./useFilterParams";

const allOperators: OperatorsSelectList = { id: 0, operatorName: "Të gjithë operatorët" };
const allLines: LineSelectList = {
  label: "Të gjitha linjat", value: 0, oldValue: 0, parentValue: 0, selected: false
};

// Operator and line. The line list is the chosen operator's, so picking an operator clears the
// line, and the line chip stays disabled until there is an operator: without one the list would
// be every line there is.
const FilterOperatorLine = () => {
  const { get, set } = useFilterParams();

  const operatorId = Number(get(KEYS.operatorId)) || 0;
  const lineId = Number(get(KEYS.lineId)) || 0;
  const operatorName = operatorId ? get(KEYS.operatorName) || `#${operatorId}` : "";
  const lineName = lineId ? get(KEYS.lineName) || `#${lineId}` : "";

  return (
    <>
      <FilterPopover
        label="Operatori"
        value={operatorName}
        onClear={() => set({
          [KEYS.operatorId]: "", [KEYS.operatorName]: "", [KEYS.lineId]: "", [KEYS.lineName]: ""
        })}
      >
        {(close) => (
          <Select
            placeholder="Kërko operatorin"
            paddingType="fill"
            defaultIsOpen
            isAbsolute={false}
            maxHeightList="max-h-64"
            onSelectedItemChange={(o) => {
              set({
                [KEYS.operatorId]: o?.id ? `${o.id}` : "",
                [KEYS.operatorName]: o?.id ? o.operatorName : "",
                [KEYS.lineId]: "",
                [KEYS.lineName]: ""
              });
              close();
            }}
            selectedItem={operatorId ? { id: operatorId, operatorName } : allOperators}
            emptyItem={allOperators}
            getOptionLabel={(o) => o.operatorName}
            itemToString={(o) => o?.operatorName || ""}
            asyncFunc={getAllSelectOperators}
          />
        )}
      </FilterPopover>
      <FilterPopover
        label="Linja"
        value={lineName}
        disabled={!operatorId}
        disabledTitle="Zgjedh operatorin më parë"
        onClear={() => set({ [KEYS.lineId]: "", [KEYS.lineName]: "" })}
        panelClassName="w-80"
      >
        {(close) => (
          <Select
            placeholder="Kërko linjën"
            paddingType="fill"
            defaultIsOpen
            isAbsolute={false}
            maxHeightList="max-h-64"
            onSelectedItemChange={(l) => {
              set({
                [KEYS.lineId]: l?.value ? `${l.value}` : "",
                [KEYS.lineName]: l?.value ? l.label : ""
              });
              close();
            }}
            selectedItem={lineId ? { ...allLines, value: lineId, label: lineName } : allLines}
            emptyItem={allLines}
            asyncFunc={getLinesSelectList}
            extraParams={{ operatorId }}
          />
        )}
      </FilterPopover>
    </>
  );
};

export default FilterOperatorLine;
